import './App.css'
import Footer from './section/Footer/Footer'
import Hero from './section/Hero/Hero'
import Projects from './section/Projects/Projects'
import Skills from './section/Skills/Skills'

function App() {
  return (
    <>
      <Hero/>
      <Projects/>
      <Skills/>
      <Footer/>
    </>
  )
}

export default App
